import { Pipe, PipeTransform } from '@angular/core';

const DEFAULT_MAX_LENGTH = 80;

/**
 * Pipe to truncate a filename with an ellipsis once it exceeds a max length.
 * Example: "Funders-Report-With-A-Very-Long-Descriptive-Name-...-.pdf" (120 chars)
 * Returns: "Funders-Report-With-A-Very-Long-Descriptive-Name-...-" (80 chars) + "..."
 */
@Pipe({
  name: 'truncateFilename',
  standalone: true
})
export class TruncateFilenamePipe implements PipeTransform {
  transform(fileName: string, maxLength: number = DEFAULT_MAX_LENGTH): string {
    if (!fileName || fileName.length <= maxLength) {
      return fileName;
    }

    return `${fileName.slice(0, maxLength)}...`;
  }
}
